<template>
  <div class="report2-image-caption">
    <div class="report2-image-caption__identity">
      <span class="report2-image-caption__serial">({{ serial }})</span>
      <span class="report2-image-caption__lesion">{{ annotationText || lesionName }}</span>
    </div>
    <div class="report2-image-caption__detail"><span>部位</span><b :title="locationFull">{{ locationAbbr || '—' }}</b></div>
    <div class="report2-image-caption__detail"><span>距肛門</span><b>{{ distanceText || '—' }}</b></div>
    <div class="report2-image-caption__detail"><span>大小</span><b>{{ sizeText || '—' }}</b></div>
  </div>
</template>

<script>
export default {
  name: 'Report2ImageCaption',
  props: {
    serial: { type: [Number, String], default: '' },
    lesionName: { type: String, default: '' },
    annotationText: { type: String, default: '' },
    distanceText: { type: String, default: '' },
    sizeText: { type: String, default: '' },
    locationAbbr: { type: String, default: '' },
    locationFull: { type: String, default: '' },
  },
}
</script>

<style lang="scss" scoped>
.report2-image-caption {
  min-height: 48px;
  padding: 5px 7px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-top: 0;
  background: #f7f7f7;
  color: #111;
  font-size: 13px;
  line-height: 1.4;
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

.report2-image-caption__identity,
.report2-image-caption__detail {
  display: flex;
  align-items: baseline;
  min-width: 0;
}

.report2-image-caption__identity {
  justify-content: flex-start;
  gap: 5px;
  font-weight: 700;
}

.report2-image-caption__serial {
  flex: none;
  font-variant-numeric: tabular-nums;
}

.report2-image-caption__lesion {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.report2-image-caption__detail {
  justify-content: space-between;
  gap: 8px;
  margin-top: 2px;
}
</style>
